import { useState, useCallback } from 'react';
import { usersAPI } from '@/services/api';

export const useSignup = (customerId: string) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSignup = useCallback(async (
    email: string,
    password: string,
    name?: string,
    companyName?: string
  ) => {
    if (!email || !password) {
      setError('이메일과 비밀번호를 입력해주세요.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await usersAPI.signup(email, password, customerId || undefined, name, companyName);
      setSuccess('✅ 가입 신청이 완료되었습니다.\n\n⏳ 관리자의 승인을 기다려주세요.\n승인 완료 시 이메일로 알려드립니다.');
      return { success: true };
    } catch (error: any) {
      console.error('Signup error:', error);
      let errorMessage = '가입 신청에 실패했습니다.';
      
      if (error.response?.status === 400 || error.response?.status === 409) {
        errorMessage = error.response?.data?.detail || '이미 가입된 이메일이거나 입력 정보가 올바르지 않습니다.';
      } else if (error.response?.data?.detail) {
        errorMessage = error.response.data.detail;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setError(errorMessage);
      return { success: false };
    } finally {
      setLoading(false);
    }
  }, [customerId]);

  const clearMessages = useCallback(() => {
    setError('');
    setSuccess('');
  }, []);

  return {
    loading,
    error,
    success,
    handleSignup,
    clearMessages,
    setError,
    setSuccess,
  };
};
